import ModalAlert from '../../components/modalAlert/ModalAlert'

let instance = null

export const createInstance = ($container) => {
    instance = new ModalAlert().init($container)
    return instance
}

export const getInstance = () => {
    if (!instance) {
        throw new ['No such modal instance']
    }
    return instance
}


// WEBPACK FOOTER //
// ./web/js/panels/user/UserPanelModalAlert.js